import { inject, Injectable } from '@angular/core';
import { countries } from '../constants/countries.const';
import { TranslateService } from '@ngx-translate/core';
import { Country } from '../interfaces/country.interface';

@Injectable({
	providedIn: 'root',
})
export class CountriesService {
	translateService = inject(TranslateService);

	getAllCountries(): Country[] {
		return countries.map((country) => ({
			name: this.translateService.instant(`countries.${country}`),
			code: country,
		}));
	}
}
